import React, { useState } from "react";
import api from "../../../core/api/config";
import Swal from "sweetalert2";

const ImportacaoOrganograma = () => {
  const [file, setFile] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];

    if (!selectedFile) return;

    if (!selectedFile.name.endsWith(".txt")) {
      Swal.fire("Erro", "Selecione um arquivo .txt", "error");
      return;
    }

    setFile(selectedFile);
  };

  const handleSubmit = async () => {
    if (file.size > 10 * 1024 * 1024) {
      Swal.fire("Erro", "Arquivo maior que 10MB", "error");
      return;
    }

    if (!file) {
      Swal.fire("Atenção", "Selecione um arquivo antes de enviar", "warning");
      return;
    }

    try {
      setLoading(true);

      const formData = new FormData();
      formData.append("file", file);

      const response = await api.post(
        "/api/tracking/api/organograma/importacao",
        formData,
      );

      const data = response.data;

      Swal.fire({
        title: "Importação realizada!",
        html: `
          <b>Cidade:</b> ${data.cidadeProcessada} <br/>
          <b>Total linhas:</b> ${data.totalLinhas} <br/>
          <b>Linhas válidas:</b> ${data.linhasDaCidade} <br/>
          <b>Cidades criadas:</b> ${data.cidadesCriadas} <br/>
          <b>Unidades criadas:</b> ${data.unidadesCriadas} <br/>
          <b>Equipes criadas:</b> ${data.equipesCriadas} <br/>
          <b>Ignoradas:</b> ${data.linhasIgnoradas}
        `,
        icon: "success",
      });

      setFile(null);
    } catch (error) {
      console.error(error);

      if (error.response?.status === 400) {
        Swal.fire("Erro", "Arquivo inválido", "error");
      } else {
        Swal.fire("Erro", "Erro interno ao importar", "error");
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="page-wrapper">
      <div className="content container-fluid">
        {/* HEADER */}
        <div className="page-header">
          <div className="page-title">
            <h4>Importação Organograma</h4>
            <h6>Importação de organograma por arquivo TXT</h6>
          </div>
        </div>

        {/* CARD PRINCIPAL */}
        <div className="card">
          <div className="card-body">
            <div className="mb-3">
              <label className="form-label">Arquivo TXT</label>
              <input
                type="file"
                className="form-control"
                accept=".txt"
                onChange={handleFileChange}
              />
            </div>

            <button
              className="btn btn-primary"
              onClick={handleSubmit}
              disabled={loading}
            >
              {loading ? "Importando..." : "Importar"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ImportacaoOrganograma;
